import { setToken } from '@/lib/token';
import { userService } from '@/services/user-service';
import { wait } from '@/utils/utils';

let refreshTokenPromise: Promise<void> | undefined;

async function refreshTokenFn() {
  try {
    await wait(1000);
    const { token } = await userService.newToken();
    if (token) {
      setToken(token);
    }
    refreshTokenPromise = undefined;
  } catch (error) {
    refreshTokenPromise = undefined;
  }
}

export function refreshToken() {
  if (!refreshTokenPromise) {
    refreshTokenPromise = refreshTokenFn();
  }
}
